// module
import React from 'react';
import { Box, Container, Typography, List, Divider } from '@mui/material';
// hooks
import { useTranslation } from 'react-i18next';
// components
import Card from './Card';
// style
import classes from './Technologies.module.scss';
// constants

const Technologies = (props) => {
  const { t } = useTranslation();

  const { data } = props;
  if (!data?.length) return null;
  return (
    <Box className={classes.technologies}>
      <Container>
        <Typography
          variant='p'
          className={classes.title}
        >{t('YouWillMaster')}</Typography>
        <Divider className={classes.divider}/>
        <List className={classes.list}>
          {data?.map((e, i) => (
            <Card data={e} key={i}/>
          ))}
        </List>
      </Container>
    </Box>
  );
};

export default Technologies;
